import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tile } from 'foundations-components/transitional/components/Tile';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import FeedbackQuestion from './FeedbackQuestion';
import FollowUp from './FollowUp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackTile = ({
  contactProperties,
  surveyType,
  feedbackResponse,
  surveyConfig,
  handleClickSubmit,
  handleFollowUpChange,
  device,
  isTest,
  setRating
}) => /*#__PURE__*/_jsxs(Tile, {
  children: [isTest && /*#__PURE__*/_jsx(Ribbon, {
    use: "sorbet",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feedbackPublicUi.testSurvey"
    })
  }), /*#__PURE__*/_jsx(FeedbackQuestion, {
    contactProperties: contactProperties,
    device: device,
    rating: feedbackResponse.rating,
    setRating: setRating,
    surveyConfig: surveyConfig,
    surveyType: surveyType
  }), /*#__PURE__*/_jsx(FollowUp, {
    feedbackResponse: feedbackResponse,
    handleClickSubmit: handleClickSubmit,
    handleFollowUpChange: handleFollowUpChange,
    isTest: isTest,
    surveyConfig: surveyConfig,
    surveyType: surveyType
  })]
});
export default FeedbackTile;